import type { Nullable } from '@hr/common/types'
import { useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import { SalaryDashboardTab } from './SalaryDashboardTab'
import { SalaryHistoryTab } from './SalaryHistoryTab'

type TabsAvailable = 'dashboard' | 'salaryhistory'

export function SalaryHistoryView() {
	const { t } = useTranslation()
	const [activeTab, setActiveTab] = useState<Nullable<TabsAvailable>>('dashboard')

	return (
		<Tabs onSelect={(tab) => setActiveTab(tab as TabsAvailable)} activeKey={activeTab as TabsAvailable}>
			<Tab eventKey="dashboard" title={t('CompensationSummary', 'Palkkayhteenveto')}>
				<SalaryDashboardTab />
			</Tab>
			<Tab eventKey="salaryhistory" title={t('SalaryHistory', 'Palkkahistoria')}>
				<SalaryHistoryTab />
			</Tab>
		</Tabs>
	)
}
